module.exports = __webpack_public_path__ + "img/volume-max-pink.b6e7d961.svg";